<template>
  <div class="product-section">

    <div class="modal-heading">
      <h2>{{$t('FileCloud Server')}}</h2>
      <p>{{$t('Run FileCloud on your own infrastructure')}}</p>
    </div>

    <div class="row">

      <div class="col-12 col-md-4">
        <PricingCard
          :name="$t('Essentials')"
          :product="sectionProducts.essentials"
          :benefits="benefits.essentials"
          @select="onSelect('essentials')"
        />
      </div>
      <div class="col-12 col-md-4 mt-3 mt-md-0">
        <PricingCard
          :name="$t('Advanced')"
          :product="sectionProducts.advanced"
          :benefits="benefits.advanced"
          recommended
          @select="onSelect('advanced')"
        />
      </div>
      <div class="col-12 col-md-4 mt-3 mt-md-0">
        <PricingCard
          :name="$t('Service Provider')"
          :product="sectionProducts.spla"
          :benefits="benefits.spla"
          @select="onSelect('spla')"
        />
      </div>

    </div>
  </div>
</template>

<script>
import { formatPrice, formatInlinePrice } from '@/utils/checkout';
import { serverBenefits } from '@/constants/checkout';
import PricingCard from '@/components/Checkout/PricingCard.vue';

export default {
  name: 'Server',
  components: {
    PricingCard
  },
  props: {
    currentProps: {
      type: Object,
      default: () => {}
    },
    products: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      benefits: serverBenefits
    }
  },
  computed: {
    sectionProducts() {
      return this.products[this.currentProps.group] ? this.products[this.currentProps.group] : {}
    },
    splaProducts() {
      return this.products.serviceprovider
    }
  },
  mounted() {
    this.$emit('settings', {
      secondary: (this.currentProps.previousStep) ? 'Back' : null
    })
  },
  methods: {
    onSelect(type) {
      if(this.sectionProducts[type] && this.sectionProducts[type].allowusertobuy) {
        this.$emit('changeStep', { step: 'details', props: { type } });
      } else {
        this.$modal.show('request-quote');
      }
    },
    onClickSecondary() {
      this.$emit('changeStep', { step: 'welcome' });
    },
    formatPrice,
    formatInlinePrice
  }
};
</script>
